/* Settings에서 사용되는 value들에 대한 정의 */

// Type definitions
interface EnumTypeDef {
  [key: string]: {
    value: number
    labelKey: string
  }
}

class EnumObj {
  typeDef: EnumTypeDef;
  [key: string]: any

  constructor(typeDef: EnumTypeDef) {
    this.typeDef = {
      ...typeDef,
    }
    this.init()
  }

  init(): void {
    Object.keys(this.typeDef).forEach((key) => {
      this[key] = this.typeDef[key].value
    })
  }

  getLabelKey(key: string): string | null {
    if (this.typeDef[key] != null) {
      return this.typeDef[key].labelKey
    }
    return null
  }

  getKeyByValue(value: number): string | null {
    let resKey: string | null = null
    Object.keys(this.typeDef).some((key) => {
      if (this.typeDef[key].value === value) {
        resKey = key
        return true
      }
      return false
    })
    return resKey
  }

  getLabelKeyByValue(value: number): string | null {
    const typeObj = Object.keys(this.typeDef).find((key) => this.typeDef[key].value === value)
    if (typeObj != null) {
      return this.typeDef[typeObj].labelKey
    }
    return null
  }
}

const contactTypeDef = {
  COMPANY: {
    value: 0,
    labelKey: 'settings.values.contactType.company',
  },
  ORGANIZATION: {
    value: 1,
    labelKey: 'settings.values.contactType.organization',
  },
  CUSTOMER: {
    value: 2,
    labelKey: 'settings.values.contactType.customer',
  },
  PERSONAL: {
    value: 3,
    labelKey: 'settings.values.contactType.personal',
  },
  SUGGESTED: {
    value: 4,
    labelKey: 'settings.values.contactType.suggested',
  },
} as const

export const CONTACT_TYPE = new EnumObj(contactTypeDef)

const mailboxTypeDef = {
  SENT: {
    value: 0,
    labelKey: 'mailbox.displayName.sent',
  },
  TRASH: {
    value: 1,
    labelKey: 'mailbox.displayName.trash',
  },
  ARCHIVE: {
    value: 2,
    labelKey: 'mailbox.displayName.archive',
  },
  SPAM: {
    value: 3,
    labelKey: 'mailbox.displayName.junk',
  },
} as const

export const MAILBOX_TYPE = new EnumObj(mailboxTypeDef)

export const FontFamilyMap: Record<string, string> = {
  None: '',
  Arial: 'Arial, Helvetica, sans-serif',
  Calibri: 'Calibri, Arial, Helvetica, sans-serif',
  'Courier New': 'Courier New, Courier, monospace',
  Georgia: 'Georgia, serif',
  Helvetica: 'Helvetica, Arial, sans-serif',
  'Lucida Console': 'Lucida Console, Monaco, monospace',
  'Malgun Gothic': 'Malgun Gothic, Calibri, Arial, sans-serif',
  'Segoe UI': 'Segoe UI, Arial, sans-serif',
  Tahoma: 'Tahoma, Geneva, sans-serif',
  'Trebuchet MS': 'Trebuchet MS, Helvetica, sans-serif',
  'Times New Roman': 'Times New Roman, Times, serif',
  Verdana: 'Verdana, Geneva, sans-serif',
}

export const FontSizeMap: Record<string, string> = {
  '8pt': '8pt',
  '9pt': '9pt',
  '10pt': '10pt',
  '11pt': '11pt',
  '12pt': '12pt',
  '14pt': '14pt',
  '16pt': '16pt',
  '18pt': '18pt',
  '20pt': '20pt',
  '22pt': '22pt',
  '24pt': '24pt',
  '26pt': '26pt',
  '28pt': '28pt',
  '36pt': '36pt',
  '48pt': '48pt',
}

export const TextColorMap: Record<string, string> = {
  black: '#000000',
  blue: '#0433ff',
  brown: '#aa7942',
  turquoise: '#00fdff',
  green: '#00f900',
  claret: '#ff40ff',
  orange: '#ff9300',
  purple: '#942192',
  red: '#ff2600',
  yellow: '#fffb00',
  white: '#ffffff',
}

export const BackColorMap: Record<string, string> = {
  lightTurquoise: '#80ffff',
  lightGreen: '#80ff80',
  lightYellow: '#ffff80',
  lightOrange: '#ffc080',
  lightRed: '#ff8080',
  lightPink: '#ff80ff',
  black: '#000000',
  white: '#ffffff',
}

const ext = {
  CONTACT_TYPE,
  FontFamilyMap,
  FontSizeMap,
  TextColorMap,
  BackColorMap,
}

const todoFilterTypeDef = {
  all: {
    value: 0,
    labelKey: 'settings.values.todoFilterType.all',
  },
  today: {
    value: 1,
    labelKey: 'settings.values.todoFilterType.today',
  },
  important: {
    value: 2,
    labelKey: 'settings.values.todoFilterType.important',
  },
  planned: {
    value: 3,
    labelKey: 'settings.values.todoFilterType.planned',
  },
  overdue: {
    value: 4,
    labelKey: 'settings.values.todoFilterType.overdue',
  },
  completed: {
    value: 5,
    labelKey: 'settings.values.todoFilterType.completed',
  },
  focusDate: {
    value: 6,
    labelKey: 'settings.values.todoFilterType.focusDate',
  },
} as const

export const TODO_FILTER_TYPE = new EnumObj(todoFilterTypeDef)

export interface SettingsInterface {
  applySettings: () => void
}

export default ext
